import React from 'react'
import { Status, ajax, parseJson, subscribe, unsubscribe } from '../../twd/twd'

export default () => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [savedSearches, setSavedSearches] = React.useState([])
    const [ts, setTs] = React.useState(Date.now())
    const lastAbort = React.useRef()

    React.useEffect(() => {

        var dismounted = false
        ;(async () => {
        if (status!==Status.LOADING) return

        try {
            if (lastAbort.current) {
                lastAbort.current()
            }

            let {data, abort} = ajax({
                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
                method: 'GET'
            })
            lastAbort.current = abort

            let rs = ((await data) || [])
                .map(a => {
                    a.modified = new Date(a.modified)
                    a.queryText = parseJson(a.formText)
                    a.searchParams = (a.queryText || {}).metadata || a.queryText || {}
                    return a
                })
                .filter(a => {
                    return a.searchParams.searchType === 'offers'
                })
                .sort((a,b) => b.modified.valueOf() - a.modified.valueOf())

            if (dismounted) return

            setSavedSearches(rs)

            setStatus(Status.LOADED)
        } catch(e) {
            if (dismounted) return
            setStatus(Status.FAILED_TO_LOAD)
        }
        })()

        return () => {
            dismounted = true

            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
        }
    }, [ts])

    React.useEffect(() => {
        let subId = subscribe('search_saved.advanced_screener_use_saved_searches', () => {
            setStatus(Status.LOADING)
            setTs(Date.now())
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    React.useEffect(() => {
        let subId = subscribe('manage_saved_searches.advanced_screener_use_saved_searches', () => {
            setStatus(Status.LOADING)
            setTs(Date.now())
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])

    return { status, savedSearches }

}


// WEBPACK FOOTER //
// ./src/advanced-screener/saved-searches/use-saved-searches.js